import './loading.css';

export function Loading() {
    return <div className="dot-loader" />;
}
